import React, { forwardRef, HTMLAttributes } from "react";
// This import correctly points to your refactored `animated_icon.tsx` file
import { createAnimatedIcon } from "./animatedIcon";
import LoaderIcon from "./loader_icon";

// 1. Import the new CSS file
import "./loader.css";

export interface LoaderUIProps {
    /**
     * Loader size(font-size) in px/em/rem/etc...
     * @default 2rem
     */
    uiSize?: string;
}

export type LoaderProps = HTMLAttributes<HTMLDivElement> & LoaderUIProps;

// createAnimatedIcon component
// This line works because createAnimatedIcon is exported from ../icons/animated_icon.tsx
const SpinIcon = createAnimatedIcon(LoaderIcon);

/**
 * Simple loader
 */
const Loader = forwardRef<HTMLDivElement, LoaderProps>(
    (
        {
            children,
            uiSize, // We'll pass this to CSS
            className,
            style,
            ...other
        },
        ref
    ) => {
        
        // 2. Build the class list
        const classNames = [
            "loader", // Base class
            className,
        ]
            .filter(Boolean)
            .join(" ");

        // 3. Build inline styles for dynamic properties
        const inlineStyles: any = {
            ...style, // Pass through parent styles
        };

        // Only set the custom property if uiSize is provided
        // The CSS file will handle the default "2rem" value
        if (uiSize) {
            inlineStyles["--loader-size"] = uiSize;
        }

        // 4. Render the component
        return (
            <div
                {...other}
                ref={ref}
                className={classNames}
                style={inlineStyles}
            >
                <SpinIcon className="loader-icon" />
                {children}
            </div>
        );
    }
);

Loader.displayName = "Loader";

export default Loader;

